// runtime-config.ts
// Export a runtimeConfig object that checks window.ENV first, then falls back to build-time values

export const runtimeConfig = {
  get apiBaseUrl(): string {
    // Feedback is one shared staging-hosted board, regardless of which Director
    // application build serves this hostname.
    if (window.location.hostname.toLowerCase() === 'feedback.director.services') return 'https://api.director.services';
    return window.ENV?.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '';
  },
  get mapKey(): string {
    return window.ENV?.VITE_MAP_KEY || import.meta.env.VITE_MAP_KEY || '';
  },
  get apiKey(): string {
    return window.ENV?.VITE_API_KEY || import.meta.env.VITE_API_KEY || '';
  },
  get authDomain(): string {
    return window.ENV?.VITE_AUTH_DOMAIN || import.meta.env.VITE_AUTH_DOMAIN || '';
  },
  get databaseUrl(): string {
    return window.ENV?.VITE_DATABASE_URL || import.meta.env.VITE_DATABASE_URL || '';
  },
  get projectId(): string {
    return window.ENV?.VITE_PROJECT_ID || import.meta.env.VITE_PROJECT_ID || '';
  },
  get storageBucket(): string {
    return window.ENV?.VITE_STORAGE_BUCKET || import.meta.env.VITE_STORAGE_BUCKET || '';
  },
  get messagingSenderId(): string {
    return window.ENV?.VITE_MESSAGING_SENDER_ID || import.meta.env.VITE_MESSAGING_SENDER_ID || '';
  },
  get environment(): string {
    return window.ENV?.ENVIRONMENT || import.meta.env.MODE || 'development';
  },
  get buildCommit(): string {
    return window.ENV?.BUILD_COMMIT || import.meta.env.VITE_BUILD_COMMIT || 'unknown';
  },
  get dwtLicenseKey(): string {
    return window.ENV?.DWT_LICENSE_KEY || import.meta.env.VITE_DWT_LICENSE_KEY || '';
  }
};
